var messages = {
  networkError: '网络异常',
  uploadPending: '等待上传中...',
  uploadFailed: '上传失败',
  uploading: '上传中',
  fileUploading: '文件上传中',
  uploadFile: '上传文件',
  clickOrDragToUpload: '点击或者拖动文件到虚线框内上传',
  ctrlVToPasteImage: 'Ctrl + V 粘贴截图',
  uploadImage: '上传图片'
};
export default messages;